import React from "react";
import { Modal } from "react-bootstrap";
import { Button } from "@zendeskgarden/react-buttons";
import { t } from "../../translations/translation.service";
import styles from "./index.module.scss";

export interface CvConfirmLoadedDataModalProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const CvConfirmLoadedDataModal: React.FC<CvConfirmLoadedDataModalProps> = ({ show, onConfirm, onCancel }) => (
  <Modal centered show={show} onHide={onCancel}>
    <Modal.Header closeButton className="h5">
      {t("Validação dos dados carregados")}
    </Modal.Header>
    <Modal.Body>
      {t("CvConfirmacaoDadosCarregados")}
    </Modal.Body>
    <Modal.Footer className="justify-content-center">
      <Button isBasic onClick={onCancel} className={`mx-2 ${styles['confirm-cancel-btn']}`}>
        {t("Não")}
      </Button>
      <Button isPrimary onClick={onConfirm} className={`mx-2 ${styles['confirm-ok-btn']}`}>
        {t("Sim")}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default CvConfirmLoadedDataModal;
